import { useTranslation } from 'react-i18next';
import styled from '@emotion/styled';
import { tokens, Text, Badge } from '@hotjar/hotsauce';
import { UpsellPopover } from '@hotjar/upsell';
import { upsell } from '@hotjar/webapp/domains/revenue/upsell';
import type { Site } from '@hotjar/site';

import { SmartPanelSegment } from '../SmartPanelBlocks';
import { SmartPanelSpacedTextWithBadge } from '../SmartPanelSpacedTextWithBadge';
import type { SessionErrorsUpsellProps } from '../../../constants-types/SessionErrors';

const PanelSegment = styled(SmartPanelSegment)`
  border-bottom: ${tokens.spacer.x0pt5} solid ${tokens.color.ui_border_light};
  flex-direction: column;
`;

const StyledText = styled(Text)`
  margin: ${tokens.spacer.x2} 0;
`;

export function SessionErrorsUpsell({ currentSite }: SessionErrorsUpsellProps): JSX.Element {
  const { t } = useTranslation('heatmaps');

  return (
    <PanelSegment>
      <UpsellPopover
        title={t('smart-panel.session-errors.upsell.upgrade-title')}
        text={t('smart-panel.session-errors.upsell.description')}
        upgradeMessage={t('smart-panel.session-errors.upsell.upgrade-description')}
        handleUpgradeClick={() => {
          upsell({
            site: currentSite as Site,
            referrer: 'recordings.heatmaps_error_widget.empty',
          });
        }}
        placement="bottom-end"
        trigger="mouseenter focus"
      >
        <div>
          <SmartPanelSpacedTextWithBadge
            text={t('smart-panel.session-errors.title')}
            icon="code_dev"
            badge={
              <Badge kind="custom" color={tokens.color.azure} size="s">
                {t('smart-panel.session-errors.upsell.scale-plan')}
              </Badge>
            }
          />
          <StyledText as="p" textType="caption" textColor="text_disabled">
            {t('smart-panel.session-errors.upsell.description')}
          </StyledText>
        </div>
      </UpsellPopover>
    </PanelSegment>
  );
}
